import { VoiceProduct } from '@shared/models/voice-product.model';
import { MobilePhoneDetails } from '../../modules/mobilephone/components/mobilephone-search/mobilephone-details/mobilephone-details.component';
import { VoiceSubscriptionOffering } from '../../modules/subscription/models/offerings-response.model';
import { HardwareVariant } from '@app/sales/modules/mobilephone/models/mobilephone-variant';

export class AddNewMobilePhoneAction {
  public static readonly type = '[MobilePhone] Add new mobile phone';
  constructor(
    public mobilePhoneVariant: HardwareVariant,
    public mobilePhoneDetails: MobilePhoneDetails,
    public isManualRegistration: boolean,
    public newMobileProductId?: string,
    public voiceProductToClone?: VoiceProduct
  ) {}
}
export class AddMobilePhoneReplacementAction {
  public static readonly type = '[MobilePhone] Add mobile phone replacement';
  constructor(
    public mobilePhonetype: HardwareVariant, //TODO; Rename
    public mobilePhoneDetails: MobilePhoneDetails,
    public existingAgreementId: string,
    public isManualRegistration: boolean
  ) {}
}
export class SetSelectedMobilePhoneIdAction {
  public static readonly type = '[MobilePhone] Set selected mobile phone id';
  constructor(public mobilePhoneId: string) {}
}

export class SetNewVoiceProductOnMobileProductAction {
  public static readonly type = '[MobilePhone] Set new voice product on mobile product';
  constructor(
    public mobileProductId: string,
    public voiceOffering: VoiceSubscriptionOffering,
    public voiceProductToClone?: VoiceProduct
  ) {}
}
export class SetVoiceProductOnMobileProductAction {
  public static readonly type = '[MobilePhone] Set voice product on mobile product';
  constructor(
    public productId: string,
    public voiceProductId: string
  ) {}
}
export class SetExistingVoiceSubscriptionOnMobileProductAction {
  public static readonly type = '[MobilePhone] Set existing voice subscription on mobile product';
  constructor(
    public productId: string,
    public subscriptionId: string
  ) {}
}
export class RemoveMobileProductAction {
  public static readonly type = '[MobilePhone] Remove mobile product';
  constructor(public productId: string) {}
}
export class RemoveVoiceProductFromMobileProductAction {
  public static readonly type = '[MobilePhone] Remove voice product from mobile product';
  constructor(public mobileProductId: string) {}
}
export class ResetMobilePhoneProductState {
  public static readonly type = '[MobilePhone] Reset mobile phone product state';
}
export class SetSelectedMobileAgreementIdAction {
  public static readonly type = '[Mobile Agreement] Set selected mobile agreement id';
  constructor(public selectedMobileAgreementId: string) {}
}

export class SetIsValidatingImeiAction {
  public static readonly type = '[MobilePhone] Set is validating imei action';
  constructor(public isValidatingImei: boolean) {}
}
